import { nectarApi } from './client'
import type { CefrLevel, PaginatedResponse, ProficiencyAssessment, SpeechQuestion, TextQuestion } from './models'

export const createAssessment = (body: { selfAssessedLevel: CefrLevel; language: string }) =>
  nectarApi.post<ProficiencyAssessment>('/v1/proficiency-assessments', body)

export const getAssessmentsByLanguage = (language: string) =>
  nectarApi.get<PaginatedResponse<ProficiencyAssessment>>('/v1/proficiency-assessments', {
    language,
    limit: 50
  })

export const getAssessment = (id: string) =>
  nectarApi.get<ProficiencyAssessment>(`/v1/proficiency-assessments/${id}`)

export const getTextQuestion = (id: string) =>
  nectarApi.get<TextQuestion | null>(`/v1/proficiency-assessments/${id}/text-questions`)

export const submitTextAnswer = (id: string, body: { questionId: string; selectedOptionIndex: number | null }) =>
  nectarApi.post(`/v1/proficiency-assessments/${id}/text-answers`, body)

export const completeTextPhase = (id: string) =>
  nectarApi.post(`/v1/proficiency-assessments/${id}/complete-text`)

export const getSpeechQuestions = (id: string) =>
  nectarApi.get<SpeechQuestion[]>(`/v1/proficiency-assessments/${id}/speech-questions`)

export const submitSpeechAnswer = (id: string, formData: FormData) =>
  nectarApi.post(`/v1/proficiency-assessments/${id}/speech-answers`, formData)

export const completeAssessment = (id: string) =>
  nectarApi.post(`/v1/proficiency-assessments/${id}/complete`)
